import { render } from "./SinhyupV3.vue?vue&type=template&id=3b5af1bd&scoped=true"
import script from "./SinhyupV3.vue?vue&type=script&lang=js"
export * from "./SinhyupV3.vue?vue&type=script&lang=js"

import "./SinhyupV3.vue?vue&type=style&index=0&id=3b5af1bd&scoped=true&lang=css"
import "./SinhyupV3.vue?vue&type=style&index=1&id=3b5af1bd&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b5af1bd"]])

export default __exports__